'use client';

import React, { ReactNode, useCallback } from 'react';

import { isFunction } from 'lodash-es';

// import { useTranslation } from 'react-i18next';
import { NeuButton, NeuModal } from '@hcahealthcaredpx/neutron-react';

// import styles from './Modal.module.css';
import { useModalContext } from './modal-context';

interface ModalProps {
  name: string;
  label: string;
  children: ReactNode;
  handleModalAccept?: () => void;
  handleModalDecline?: () => void;
  declineButtonText?: string;
  acceptButtonText?: string;
  hideDecline?: boolean;
  acceptButtonKind?: 'primary' | 'tertiary';
  skipDeclineHandlerOnDismiss?: boolean;
}

export const GenericModal = ({
  name,
  label,
  children,
  declineButtonText,
  acceptButtonText,
  handleModalDecline,
  handleModalAccept,
  hideDecline,
  acceptButtonKind = 'primary',
  skipDeclineHandlerOnDismiss = false,
}: ModalProps): JSX.Element => {
  const { isOpen, closeModal } = useModalContext();

  const dismissModal = useCallback(() => {
    if (skipDeclineHandlerOnDismiss) {
      closeModal(name);
      return;
    }
    if (isFunction(handleModalDecline)) {
      handleModalDecline();
    }
    closeModal(name);
  }, [handleModalDecline, closeModal, skipDeclineHandlerOnDismiss, name]);

  const accept = useCallback(() => {
    if (isFunction(handleModalAccept)) {
      handleModalAccept();
    }
    closeModal(name);
  }, [handleModalAccept, closeModal, name]);

  const formattedLabel = name
    .split('_')
    .map((x) => x.charAt(0).toUpperCase() + x.slice(1).toLocaleLowerCase())
    .join(' ');
  const ariaLabel = label || formattedLabel;

  return (
    <NeuModal
      active={isOpen(name)}
      label={label}
      aria-label={ariaLabel}
      size="medium"
      onNeuDismiss={dismissModal}
      onClick={(ev) => ev.stopPropagation()} // Prevent from closing on click away
    >
      <NeuModal.Content>{children}</NeuModal.Content>

      <NeuModal.Footer>
        {/* todo: check this <div className="flex-column-reverse flex-md-row"></div> */}
        {/* className={styles.footerButton} */}
        {!hideDecline && (
          <NeuButton
            onNeuClick={() => {
              if (isFunction(handleModalDecline)) {
                handleModalDecline();
              }
              closeModal(name);
            }}
            kind="tertiary"
          >
            {declineButtonText || 'Cancel'}
          </NeuButton>
        )}
        <NeuButton onNeuClick={accept} kind={acceptButtonKind}>
          {acceptButtonText || 'Confirm'}
        </NeuButton>
      </NeuModal.Footer>
    </NeuModal>
  );
};
